import script from "./PartnerOnboarding.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerOnboarding.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerOnboarding.vue?vue&type=style&index=0&id=70c27335&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c27335"]])

export default __exports__